export const URL_PARAM_CUSTOMER_ID = 'customerId'
export const URL_PARAM_START_DATE = 'startReportingPeriodStartDate'
export const URL_PARAM_END_DATE = 'endReportingPeriodStartDate'
